import TableColumnDataType from "./tableColumnDataType";

export default class Filter {
  public fieldName: string = "";
  public fieldDisplayName: string = "";
  public fieldValue: string = "";
  public fieldDisplayValue: string = "";
  public fieldUnit: string = "";
  public fieldType: TableColumnDataType = TableColumnDataType.String;
  public fieldLogic: string = "";
}
